module.exports = __webpack_public_path__ + "img/4.dc002ef6.svg";